import { NgModule } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { ListMapDataSetComponent } from './list-map-data-set.component';
import { CardComponent } from '../../@theme/components/card/card.component';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTableModule } from '@angular/material/table';
import { TableDataSetModule } from '../table-data-set';
import { RouterLink } from '@angular/router';
import { NgxVisibilityModule } from 'ngx-visibility';
import { CardDataSetModule } from '../card-data-set';
import { DurationTextModule } from '../duration-text';
import { FilterDataSetModule } from '../filter-data-set';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatSidenavModule } from '@angular/material/sidenav';
import { NgScrollbar } from 'ngx-scrollbar';
import { ElementsForViewPipe, IsHasElementPipe } from '../../pipes';
import { MatChipsModule } from '@angular/material/chips';
import { MatBadgeModule } from '@angular/material/badge';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDividerModule } from '@angular/material/divider';
import { FilterSearchDataSetModule } from '../filter-search-data-set';
import { MatInputModule } from '@angular/material/input';
import { ScrollContainerModule } from '../scroll-container';
import { ColumnManagementComponent } from './components/column-management/column-management.component';
import { MatDialogModule } from '@angular/material/dialog';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatListModule } from '@angular/material/list';
import { FormsModule } from '@angular/forms';


@NgModule({
  declarations: [
    ListMapDataSetComponent,
    ColumnManagementComponent
  ],
  imports: [
    CommonModule,
    CardComponent,
    MatButtonModule,
    MatCheckboxModule,
    MatTableModule,
    TableDataSetModule,
    CardDataSetModule,
    RouterLink,
    NgxVisibilityModule,
    CardDataSetModule,
    DurationTextModule,
    FilterDataSetModule,
    MatCardModule,
    MatIconModule,
    MatSidenavModule,
    NgScrollbar,
    IsHasElementPipe,
    MatChipsModule,
    NgOptimizedImage,
    MatBadgeModule,
    MatTooltipModule,
    MatDividerModule,
    ElementsForViewPipe,
    FilterSearchDataSetModule,
    MatInputModule,
    ScrollContainerModule,
    MatDialogModule,
    DragDropModule,
    MatListModule,
    FormsModule
  ],
  exports: [
    ListMapDataSetComponent
  ]
})
export class ListMapDataSetModule { }
